/** Legacy series retrofit, issue #540. Existing posts only; no MDX modified. */
export default {
  slug: "copilot-waves",
  publishDate: '2027-01-01',
  title: "Microsoft 365 Copilot Waves: from foundation to governance and security",
  shortTitle: "Copilot Waves",
  description: "Explore 15 connected guides on Microsoft 365 Copilot waves, agents, data protection, governance, Australian compliance and security planning.",
  intro: "Follow the Microsoft 365 Copilot evolution from its early releases through agentic capabilities, governance, Australian compliance considerations and security planning. These are editorial explainers, not a claim that any customer deployment has been tested.",
  audience: "Microsoft 365 administrators, IT leaders, security architects and Australian compliance teams.",
  whoItsFor: ['Microsoft 365 administrators', 'Security and governance professionals', 'Australian IT and business decision-makers'],
  whatYouWillLearn: ["Trace the Copilot Waves progression across the existing editorial series","Identify governance and data-protection considerations before enabling agentic features","Find the related Australian compliance and security planning articles"],
  parts: [
    { id: 55, plannedTitle: "Wave 1: the foundation" },
    { id: 56, plannedTitle: "Wave 2: pages and agents" },
    { id: 57, plannedTitle: "Copilot Researcher and Analyst agents" },
    { id: 58, plannedTitle: "Wave 3: Australian briefing" },
    { id: 59, plannedTitle: "Agentic features and apps" },
    { id: 60, plannedTitle: "Agent 365 and governance" },
    { id: 61, plannedTitle: "Purview sensitivity labels" },
    { id: 62, plannedTitle: "SharePoint and Teams governance" },
    { id: 63, plannedTitle: "Copilot Cowork and data residency" },
    { id: 64, plannedTitle: "Copilot Business for SMBs" },
    { id: 65, plannedTitle: "Work IQ and privacy" },
    { id: 66, plannedTitle: "Copilot Studio release wave" },
    { id: 67, plannedTitle: "ASD Blueprint and Copilot" },
    { id: 68, plannedTitle: "Australian data residency and IRAP" },
    { id: 69, plannedTitle: "Security roadmap and Essential Eight" },
  ],
  held: [],
  totalParts: 15,
  methodology: "Existing editorial series, grouped according to the six clusters in docs/plans/copilot-waves-social-media-campaign-2026.md.",
  methodologyDetail: 'This is a navigation hub for previously authored articles. It does not report a completed pilot, customer implementation or independently verified security outcome. Publication visibility is inherited from each existing post.',
  sourceLedgerNote: 'Technical claims and source references remain in the linked articles; the hub adds no independent technical assertions.',
  faqs: [
    { question: 'Are all articles in this collection published?', answer: 'Only published members appear as linked articles on the production site. Draft members are available for beta review and are otherwise shown as upcoming.' },
    { question: 'Is this a completed deployment or security assessment?', answer: 'No. This is an editorial reading collection. It does not represent completed tenant testing or a verified pilot.' },
  ],
  cta: {
    heading: 'Want to assess your Microsoft 365 environment?',
    text: 'Explore the related guidance or contact EDUC4TE about training and governance reviews.',
    primary: { label: 'Explore Copilot readiness', href: '/copilot-readiness' },
    secondary: { label: 'Contact EDUC4TE', href: '/contact' },
  },
  lastReviewed: '2026-10-28',
};
